import React from 'react'
import PropTypes from 'prop-types'
import {
  plusMinusLabelHelper,
  upDownArrowLabelHelper,
} from '../../Helpers/FundUtility.js'
import { formatDateStandard } from '../../../../global/formatters/string-formatter.js'
import './Fund.css'
import Tooltip from '../../../Tooltip/Tooltip.jsx'

function FundBasicsItem({
  label,
  subLabel,
  subLabelDate,
  plusMinusLabel,
  fundValue,
  preValueLabel,
  postValueLabel,
  upDownArrowLabel,
  isTooltip,
  tooltipContent,
  tooltipHead,
  tooltipDirection,
  tooltipId,
}) {
  return (
    (fundValue || null) && (
      <div className="js-basic-item u-lg-size3of12 u-md-size4of12 u-sm-size6of12 u-marginBottom3gu fund-item u-sm-posRelative">
        {isTooltip ? (
          <Tooltip
            content={tooltipContent}
            heading={tooltipHead}
            id={tooltipId}
            direction={tooltipDirection}
          >
            <p className="u-marginBottom0 u-marginRight3gu">
              <span className="u-textColorLight u-textSecondary Tooltip-label">
                {label}
              </span>
              <span className="Icon--material Tooltip-icon u-marginLeft1gu u-inline">
                info
              </span>
            </p>
          </Tooltip>
        ) : (
          <span className="u-textColorLight u-textSecondary u-textSolid">
            {label}
          </span>
        )}
        <p className="u-textSizeMsrp3 u-textSecondary u-textTruncate u-sm-textSizeMsrp1">
          {plusMinusLabel ? (
            <React.Fragment>
              {plusMinusLabelHelper(fundValue, preValueLabel, postValueLabel)}
              {upDownArrowLabel && upDownArrowLabelHelper(fundValue)}
            </React.Fragment>
          ) : (
            <React.Fragment>
              {preValueLabel}
              {fundValue}
              {postValueLabel}
              {upDownArrowLabel && upDownArrowLabelHelper(fundValue)}
            </React.Fragment>
          )}
        </p>
        {subLabelDate && (
          <React.Fragment>
            <p className="u-paddingTop1gu u-textColorLight u-textSecondary">
              {subLabel}
            </p>
            <p className="u-textColorLight u-textSecondary">
              {formatDateStandard(subLabelDate)}
            </p>
          </React.Fragment>
        )}
      </div>
    )
  )
}

FundBasicsItem.propTypes = {
  label: PropTypes.string,
  subLabel: PropTypes.string,
  subLabelDate: PropTypes.string,
  plusMinusLabel: PropTypes.bool,
  fundValue: PropTypes.string,
  preValueLabel: PropTypes.string,
  postValueLabel: PropTypes.string,
  upDownArrowLabel: PropTypes.bool,
  isTooltip: PropTypes.bool,
  tooltipContent: PropTypes.string,
  tooltipHead: PropTypes.string,
  tooltipDirection: PropTypes.string,
  tooltipId: PropTypes.string,
}

export default FundBasicsItem
